import React, {useEffect, useState} from 'react';
import Form from "react-bootstrap/Form";
import {Col, Row} from "react-bootstrap";
import {getSeriusLevel} from "../../api/apiClient";

const ComboSeriusLevel = ({
                            propTitle = '심각도',
                            propDefaultValue,
                            propOnChange = null
                          }) => {
  // 심각도 목록
  const [seriusLevel, setSeriusLevel] = useState([]);

  useEffect(() => {
    // 심각도
    getSeriusLevel()
        .then((res) => {
          setSeriusLevel(res.data.data.list);
        });
  }, []);

  return (
      <Form.Group as={Row} controlId='seriusLevel'>
        <Form.Label column md={3} className={'label text-end fw-bold'}>
          <span className={"text-danger"}>* </span>{propTitle}
        </Form.Label>
        <Col md={4} className={''}>
          <Form.Select
              aria-label="Default select example"
              className={"input input-select"}
              onChange={propOnChange}
              defaultValue={propDefaultValue}
              key={propDefaultValue}
          >
            {Array.isArray(seriusLevel) ?
                (seriusLevel.map((elem, idx) => {
                  return (
                      <option key={idx} value={elem.cd}>{elem.nm}</option>
                  )
                })) : ''}
          </Form.Select>
        </Col>
      </Form.Group>
  );
};

export default ComboSeriusLevel;